import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e261432"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon-body" }
const _hoisted_2 = { class: "icon-search" }
const _hoisted_3 = { class: "icon-list" }
const _hoisted_4 = { class: "list-container" }
const _hoisted_5 = ["onClick"]

import { ref } from 'vue'
import { Search } from '@element-plus/icons-vue'
import icons from './requireIcons'

// Props
interface Props {
  activeIcon?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    activeIcon: null
  },
  emits: ['selected'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  activeIcon?: string
}



// Emits


// 响应式状态
const name = ref('')
const iconList = ref(icons)

// 方法
const filterIcons = () => {
  iconList.value = icons
  if (name.value) {
    iconList.value = iconList.value.filter(item => item.includes(name.value))
  }
}

const selectedIcon = (name: string) => {
  emit('selected', name)
  document.body.click()
}

const reset = () => {
  name.value = ''
  iconList.value = icons
}

// 暴露方法给父组件
expose({
  reset
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        modelValue: name.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
        size: "small",
        placeholder: "请输入图标名称",
        clearable: "",
        onClear: filterIcons,
        onInput: filterIcons
      }, {
        prefix: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Search))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(iconList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "icon-item-wrapper",
            key: index,
            onClick: ($event: any) => (selectedIcon(item))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(['icon-item', { active: __props.activeIcon === item }])
            }, [
              _createVNode(_component_svg_icon, {
                "icon-class": item,
                "class-name": "icon",
                style: {"height":"25px","width":"16px"}
              }, null, 8, ["icon-class"]),
              _createElementVNode("span", null, _toDisplayString(item), 1)
            ], 2)
          ], 8, _hoisted_5))
        }), 128))
      ])
    ])
  ]))
}
}

})